export const sumAsync = async (source, selector) => {
    let sum = 0;
    for await (const value of source) {
        sum += await selector(value);
    }
    return sum;
};
